import React, { useContext, useEffect, useState } from 'react'
import { Flex, Flexed, Input, Label, Selectbox, Textauto } from '../../../utilities/Shared'
import Sheet from './Sheet'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import OptionForm from './OptionForm'
import {Plus, X} from 'lucide-react'
import { v4 as uuidv4 } from 'uuid';
import EstContext from '../../../Context/EstContext'
import Select from '../../../utilities/Select'
import PaperSelect from '../../../utilities/PaperSelect'
import Form from './Form'
import CSVMapper from './CSVMapper'



const FormSetup = ({form,setForms,option,item}) => {

    const {info, setInfo,paperlist,forms} = useContext(EstContext)
  

const addform = () => {
 const deepCopyObj = JSON.parse(JSON.stringify(info.options[option].forms[0]));
 deepCopyObj.itemid = uuidv4()
 deepCopyObj.name =`Form ${info.options[option].forms.length + 1}`
 const jj = {...info}
 let h = [...jj.options[option].forms,deepCopyObj]
jj.options[option].forms = h    
    setInfo(jj) 
}

const removeform = (id) => {
  const jj = {...info}
  let h = jj.options[option].forms
  let hh = h.filter(filt => filt.itemid !== id)
  jj.options[option].forms = hh
setInfo(jj)
}

  return (
  <>

<Tabs>
 <TabList> 
     <span style={{position:"relative",top:"10px",marginRight:"10px",textAlign:"left"}}  ><Plus color="green" size="24" strokeWidth={3} onClick={e => addform()}/></span>
    {
        item.forms?.map((item,index) => {
return <Tab><div style={{fontSize:"calc(1rem + .2vw)"}}>{item.name}
{
    index > 0 ? <X size="20" strokeWidth={3} style={{position:"relative",right:"-7px",top:"6px"}} color="rgb(255,0,0,.6)" onClick={e => removeform(item.itemid)} /> : <X size="20" strokeWidth={3} style={{position:"relative",right:"-7px",top:"6px",visibility:"hidden"}} />
}
</div></Tab>
        })
    }
    </TabList>
    {
        item?.forms.map((item,itemindex) => {
        return    <TabPanel style={{color:"#418DA7"}}><Form item={item} index={itemindex} option={option}/></TabPanel>  
        })
    }
     </Tabs>


<br />
          
{/* //////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

        <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />

        
    <div>
  
    </div>
        </>


  )
}

export default FormSetup





